import { __extends } from 'tslib';
import web2clientSounds from '@lst/web2clientapi/sound';
import classNames from 'classnames';
import * as React from 'react';
import styles from './Tabs.module.scss.js';

var Tabs = (function (_super) {
    __extends(Tabs, _super);
    function Tabs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tabs.prototype.toggleTab = function (tab) {
        if (tab === this.props.tabSelected) {
            return;
        }
        this.props.onToggleTab(tab);
        web2clientSounds.playButtonSound();
    };
    Tabs.prototype.render = function () {
        var _this = this;
        var tabs = this.props.tabs.map(function (tab, index) {
            var _a;
            var _b;
            var classNameTab = classNames(styles.tab, (_a = {},
                _a[styles.isSelected] = _this.props.tabSelected === tab.value,
                _a[styles.isUppercase] = _this.props.isUppercase,
                _a[styles.smallHeight] = _this.props.smallHeight,
                _a), (_b = _this.props) === null || _b === void 0 ? void 0 : _b.className);
            return (React.createElement("div", { className: classNameTab, key: index, onClick: function () { return _this.toggleTab(tab.value); } },
                React.createElement("div", { className: styles.tabContent }, tab.content)));
        });
        return React.createElement("div", { className: styles.container }, tabs);
    };
    return Tabs;
}(React.Component));

export { Tabs as default };
//# sourceMappingURL=Tabs.js.map
